var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortingIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sorting 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.808 12.6831C11.0521 12.439 11.4479 12.439 11.6919 12.6831L14.375 15.3661L17.058 12.6831C17.3021 12.439 17.6979 12.439 17.9419 12.6831C18.186 12.9271 18.186 13.3229 17.9419 13.5669L14.8169 16.6919C14.5729 16.936 14.1771 16.936 13.933 16.6919L10.808 13.5669C10.564 13.3229 10.564 12.9271 10.808 12.6831Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.375 8.125C14.7202 8.125 15 8.40481 15 8.75V16.25C15 16.5952 14.7202 16.875 14.375 16.875C14.0298 16.875 13.75 16.5952 13.75 16.25V8.75C13.75 8.40481 14.0298 8.125 14.375 8.125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 10C3.125 9.65481 3.40483 9.375 3.75 9.375H9.375C9.72019 9.375 10 9.65481 10 10C10 10.3452 9.72019 10.625 9.375 10.625H3.75C3.40483 10.625 3.125 10.3452 3.125 10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 5C3.125 4.65483 3.40483 4.375 3.75 4.375H14.375C14.7202 4.375 15 4.65483 15 5C15 5.34518 14.7202 5.625 14.375 5.625H3.75C3.40483 5.625 3.125 5.34518 3.125 5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 15C3.125 14.6548 3.40483 14.375 3.75 14.375H8.125C8.47019 14.375 8.75 14.6548 8.75 15C8.75 15.3452 8.47019 15.625 8.125 15.625H3.75C3.40483 15.625 3.125 15.3452 3.125 15Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingIcon);
export default __webpack_public_path__ + "static/media/sorting-icon.0d56d4891c38a4849d5b283e8cabb290.svg";
export { ForwardRef as ReactComponent };